import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";

require.context("images", true);

var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");

// https://github.com/rails/rails/issues/24257#issuecomment-705373212
window.addEventListener("turbo:load", function () {
  Rails.refreshCSRFTokens();
});

Rails.start();

// https://github.com/reactjs/react-rails#event-handling
window.Turbo = Turbo;
ReactRailsUJS.detectEvents();

var skipFirstCall = false;
ReactRailsUJS.handleEvent("turbo:load", () => {
  skipFirstCall && ReactRailsUJS.handleMount();
  skipFirstCall = true;
});

ReactRailsUJS.handleEvent("turbo:before-render", ReactRailsUJS.handleUnmount);

delete window.Turbo;

ReactRailsUJS.useContext(componentRequireContext);

// Delegated copy-to-clipboard for [data-copy-link] buttons (partner portal
// marketing cards). Bound once; survives Turbo visits.
document.addEventListener("click", (event) => {
  const button =
    event.target.closest && event.target.closest("[data-copy-link]");
  if (!button || !navigator.clipboard || button.dataset.copying) return;
  button.dataset.copying = "true";
  const original = button.textContent;
  navigator.clipboard
    .writeText(button.dataset.copyLink)
    .then(() => (button.textContent = "Copied!"))
    .catch(() => (button.textContent = "Copy failed"))
    .finally(() => {
      setTimeout(() => {
        button.textContent = original;
        delete button.dataset.copying;
      }, 2000);
    });
});
